import { useState } from "react";
import styles from "./ProviderSelector.module.scss";
import { getProviderLLM, PROVIDERS, setProviderLLM } from "./utils/AiUtils";

function ProviderSelector() {
  const [provider, setProvider] = useState(() => {
    return getProviderLLM();
  });

  const handleChange = (e) => {
    const selectedProvider = e.target.value;

    setProvider(selectedProvider);
    setProviderLLM(selectedProvider);
  };

  return (
    <div className={styles["provider"]}>
      {console.log(provider)}
      <div className={styles["label"]}>LLM Provider</div>
      <select className={styles["select"]} value={provider} onChange={handleChange} name="provider">
        {PROVIDERS.map((e) => (
          <option key={e} value={e}>
            {e}
          </option>
        ))}
      </select>
    </div>
  );
}

export default ProviderSelector;
